import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Row } from 'reactstrap';
import { AssistanceUtilitiesWithNavigate } from '../../AssistanceUtilities';
import Toast from '../../helpers/Toast';
import { GetAssistanceByDocumentDTO } from '../../models/Assistance/GetAssistanceByDocumentDTO';
import { GetDocNumberDTO } from '../../models/Assistance/GetDocNumberDTO';
import { ClientDTO } from '../../models/Client/ClientDTO';
import { EquipmentDTO } from '../../models/Equipment/EquipmentDTO';
import { CreateScheduleDTO } from '../../models/Scheduler/CreateScheduleDTO';
import { AssistanceService } from '../../services/AssistanceService';
import ButtonComponent from '../ButtonComponent';
import ClientEquipmentBidirecional, { SelectItemsProps } from '../ClientEquipmentBidirecional/ClientEquipmentBidirecional';
import SearchSelectComponent from '../SearchSelectComponent';
import { useAuth } from '../../context/AuthContext';
import InputComponent from '../InputComponent';

type CreateSchedulerFirstTabProps = {
    scheduleDTO: CreateScheduleDTO;
    setScheduleDTO: React.Dispatch<React.SetStateAction<CreateScheduleDTO>>;

    onFetchData: () => void;
};

function CreateSchedulerFirstTab(props: CreateSchedulerFirstTabProps) {

    const assistanceService = new AssistanceService();

    const navigate = useNavigate();
    const assistanceUtilities = AssistanceUtilitiesWithNavigate(navigate);
    const { preferedView } = useAuth();

    const intl = useIntl();


    const [isActiveProjectModule, setIsActiveProjectModule] = useState<boolean>(false);
    const [projectSelected, setProjectSelected] = useState<SelectItemsProps | null>(null);
    const [clientSelected, setClientSelected] = useState<SelectItemsProps | null>(
        props.scheduleDTO.clientErpId ? { value: props.scheduleDTO.clientErpId, label: props.scheduleDTO.clientName || '' } : null
    );
    const [serialNumberSelected, setSerialNumberSelected] = useState<SelectItemsProps | null>(
        props.scheduleDTO.equipmentErpId ? { value: props.scheduleDTO.equipmentErpId, label: props.scheduleDTO.equipmentSerialNumberName || '' } : null
    );
    const [equipment, setEquipment] = useState<EquipmentDTO>({
        brand: props.scheduleDTO.equipmentBrandName || '',
        model: props.scheduleDTO.equipmentModelName || '',
        sku: props.scheduleDTO.equipmentSkuName || '',
    } as EquipmentDTO);
    const [isSearchEquipmentLoading, setIsSearchEquipmentLoading] = useState<boolean>(false);
    const [carPlateSelected, setCarPlateSelected] = useState<SelectItemsProps | null>(
        props.scheduleDTO.equipmentErpId ? { value: props.scheduleDTO.equipmentErpId, label: props.scheduleDTO.equipmentCarPlateName || '' } : null
    );
    const [assistanceSelected, setAssistanceSelected] = useState<SelectItemsProps | null>(
        props.scheduleDTO.assistanceId ? { value: props.scheduleDTO.assistanceId.toString(), label: props.scheduleDTO.assistanceName || '' } : null
    );
    const [assistancesList, setAssistancesList] = useState<GetAssistanceByDocumentDTO[]>([]);
    const [observations, setObservations] = useState<string>(props.scheduleDTO.observations || '');


    const GetAssistance = async (valueAssistance: string): Promise<SelectItemsProps[]> => {
        if (isNaN(Number(valueAssistance))) {
            Toast.Show("info", "A pesquisa apenas aceita números do documento");
            return [];
        }

        var docNumber: GetDocNumberDTO = { docNumber: Number(valueAssistance) };
        const response = await assistanceService.GetAssistanceIdByDoc(docNumber);

        if (response.success === false || response.obj === null) {
            Toast.Show("error", response.message);
        }

        const list: SelectItemsProps[] = [];
        response.obj?.forEach((element: any) => {
            var item: SelectItemsProps = {
                value: element.id,
                label: `${element.docType} ${element.serie} ${element.number}`,
                data: element,
            };
            list.push(item);
        });
        setAssistancesList(response.obj || []);
        return list;
    }; useEffect(() => {
        props.setScheduleDTO({
            ...props.scheduleDTO,
            clientErpId: equipment?.client?.erpId ?? (props.scheduleDTO.clientErpId || null),
            clientName: equipment?.client?.name ?? (props.scheduleDTO.clientName || null),
            equipmentErpId: equipment?.erpId ?? (props.scheduleDTO.equipmentErpId || null),
            equipmentCarPlateName: equipment?.carPlate ?? (props.scheduleDTO.equipmentCarPlateName || null),
            equipmentSerialNumberName: equipment?.serialNumber ?? (props.scheduleDTO.equipmentSerialNumberName || null),
            equipmentBrandName: equipment?.brand ?? (props.scheduleDTO.equipmentBrandName || null),
            equipmentModelName: equipment?.model ?? (props.scheduleDTO.equipmentModelName || null),
            equipmentSkuName: equipment?.sku ?? (props.scheduleDTO.equipmentSkuName || null),
            observations: observations ?? ''
        });
    }, [clientSelected, serialNumberSelected, carPlateSelected, observations]);

    return (
        <div>
            <Row
                style={{
                    margin: "5% 0% 0% 0%",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <SearchSelectComponent
                    xl={assistanceSelected ? 9 : 12}
                    lg={assistanceSelected ? 9 : 12}
                    md={assistanceSelected ? 9 : 12}
                    sm={12}
                    xs={12}
                    label={"Assistência"}
                    loadOptions={GetAssistance}
                    onChange={(assistance: SelectItemsProps | null) => {
                        if (assistance === null) {
                            setAssistanceSelected(null);
                            setClientSelected(null);
                            setSerialNumberSelected(null);
                            setEquipment({
                                id: 0,
                                erpId: '',
                                name: '',
                                carPlate: '',
                                serialNumber: '',
                                brand: '',
                                model: '',
                                sku: '',
                                hasDataSheet: null,
                                client: {} as ClientDTO,
                            });
                            setCarPlateSelected(null);
                            props.setScheduleDTO({
                                ...props.scheduleDTO,
                                assistanceId: null,
                                assistanceName: '',
                                clientErpId: null,
                                clientName: '',
                                equipmentErpId: null,
                                equipmentCarPlateName: '',
                                equipmentSerialNumberName: '',
                                equipmentBrandName: '',
                                equipmentModelName: '',
                                equipmentSkuName: ''
                            });
                        } else {
                            const selectedAssistance = assistancesList.find(a => a.id === assistance.value);
                            if (selectedAssistance) {
                                setAssistanceSelected(assistance);
                                setClientSelected({
                                    value: selectedAssistance.clientErpId || '',
                                    label: selectedAssistance.clientName || ''
                                });
                                setSerialNumberSelected({
                                    value: selectedAssistance.equipmentErpId || '',
                                    label: selectedAssistance.equipmentSerialNumber || ''
                                });
                                setEquipment({
                                    id: 0,
                                    erpId: selectedAssistance.equipmentErpId || '',
                                    name: selectedAssistance.equipmentSerialNumber || '',
                                    carPlate: selectedAssistance.equipmentCarPlate || '',
                                    serialNumber: selectedAssistance.equipmentSerialNumber || '',
                                    brand: selectedAssistance.equipmentBrand || '',
                                    model: selectedAssistance.equipmentModel || '',
                                    sku: selectedAssistance.equipmentSku || '',
                                    hasDataSheet: null,
                                    client: {} as ClientDTO,
                                });
                                setCarPlateSelected({
                                    value: selectedAssistance.equipmentErpId || '',
                                    label: selectedAssistance.equipmentCarPlate || ''
                                });
                                props.setScheduleDTO({
                                    ...props.scheduleDTO,
                                    assistanceId: Number(assistance.value),
                                    assistanceName: `${selectedAssistance.docType} ${selectedAssistance.serie} ${selectedAssistance.number}`,
                                    clientErpId: selectedAssistance.clientErpId || null,
                                    clientName: selectedAssistance.clientName || '',
                                    equipmentErpId: selectedAssistance.equipmentErpId || null,
                                    equipmentCarPlateName: selectedAssistance.equipmentCarPlate || '',
                                    equipmentSerialNumberName: selectedAssistance.equipmentSerialNumber || '',
                                    equipmentBrandName: selectedAssistance.equipmentBrand || '',
                                    equipmentModelName: selectedAssistance.equipmentModel || '',
                                    equipmentSkuName: selectedAssistance.equipmentSku || ''
                                });
                            }
                        }
                    }}
                    value={assistanceSelected}
                    style={{ width: "100%" }}
                />

                {assistanceSelected && (
                    <ButtonComponent
                        text={intl.formatMessage({ id: "Common.Buttons.NavigateToAssistance" })}
                        onClick={() => assistanceUtilities.NavigateToAssistanceDetails(Number(assistanceSelected?.value), preferedView)}
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    />
                )}
            </Row>

            <Row
                style={{
                    margin: "0px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <ClientEquipmentBidirecional
                    isActiveProjectModule={isActiveProjectModule}
                    projectSelected={projectSelected}
                    clientSelected={clientSelected}
                    setClientSelected={setClientSelected}
                    serialNumberSelected={serialNumberSelected}
                    setSerialNumberSelected={setSerialNumberSelected}
                    equipment={equipment}
                    setEquipment={setEquipment}
                    isSearchEquipmentLoading={isSearchEquipmentLoading}
                    setIsSearchEquipmentLoading={setIsSearchEquipmentLoading}
                    isActiveSearchByCarPlate={true}
                    carPlateSelected={carPlateSelected}
                    setCarPlateSelected={setCarPlateSelected}
                    disableSoftwareFields={true}
                />
            </Row>     

            <Row
                style={{
                    margin: "3% 0% 0% 0%",
                    padding: "0px",
                }}
            >
                <InputComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"textArea"}
                    value={observations}
                    label={"Observações do Agendamento"}
                    readOnly={false}
                    onChange={(t: string) => {
                        setObservations(t);
                        props.setScheduleDTO({
                            ...props.scheduleDTO,
                            observations: t
                        });
                    }}
                    rows={4}
                />
            </Row>
        </div>
    );
}

export default CreateSchedulerFirstTab;